import React from 'react';
import img from './Info.svg';

const Info = props => <img {...props} src={img} alt="info" />;

export default Info;
